import {
  getSrmMaterialSapList,
  type MaterialSapVo,
  type SrmMaterialSapPageDto,
} from "@/apis/sap.api";
import BaseProtable from "@/components/BaseProTable";
import { PrimaryButton } from "@/components/ui/buttons/PrimaryButton";
import CommonModal from "@/components/ui/CommonModal";
import { usePageTable } from "@/hooks/baseProTable/usePageTable";
import { notifyWarning } from "@/utils/notification";
import { type TableProps } from "antd";
import { useState } from "react";
import styles from "./index.module.less";

type Props = {
  open: boolean;
  onOk: (materials: MaterialSapVo[]) => void;
  onClose: () => void;
};

export const SelectMaterialForPurchaseModal: React.FC<Props> = ({
  open,
  onOk,
  onClose,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<MaterialSapVo[]>([]);
  const [params, setParams] = useState<SrmMaterialSapPageDto>({});

  const { actionRef, fetchDatasource, columns, formRef } = usePageTable<
    MaterialSapVo,
    SrmMaterialSapPageDto
  >({
    fetchFn: getSrmMaterialSapList,
    columns: [
      {
        title: "序号",
        valueType: "index",
        width: 60,
        align: "center",
        fixed: "left",
      },
      { title: "物料编号", dataIndex: "f101", width: 150, align: "center" },
      {
        title: "物料名称",
        dataIndex: "keyword",
        hideInTable: true,
        width: 150,
        align: "center",
      },
      {
        title: "物料中文描述",
        dataIndex: "f102",
        width: 200,
        align: "center",
        search: false,
      },
      {
        title: "物料英文描述",
        dataIndex: "f103",
        width: 200,
        align: "center",
        search: false,
      },
      {
        title: "物料类型",
        dataIndex: "f104",
        width: 120,
        align: "center",
        search: false,
      },
      { title: "物料组", dataIndex: "f105", width: 120, align: "center" },

      {
        title: "物料等级",
        dataIndex: "f106",
        width: 100,
        align: "center",
        search: false,
      },
      {
        title: "基本单位",
        dataIndex: "f107",
        width: 100,
        align: "center",
        search: false,
      },
      {
        title: "安全库存",
        dataIndex: "f108",
        width: 100,
        align: "center",
        search: false,
      },
      {
        title: "价格",
        dataIndex: "f109",
        width: 100,
        align: "center",
        search: false,
      },
      {
        title: "最新采购价",
        dataIndex: "f112",
        width: 120,
        align: "center",
        search: false,
      },
      {
        title: "库存",
        dataIndex: "f110",
        width: 100,
        align: "center",
        search: false,
      },
      {
        title: "最后PO数量",
        dataIndex: "f114",
        width: 120,
        align: "center",
        search: false,
      },
      {
        title: "最后PO币种",
        dataIndex: "f115",
        width: 120,
        align: "center",
        search: false,
      },
      {
        title: "PO价格数量单位",
        dataIndex: "f116",
        width: 150,
        align: "center",
        search: false,
      },
      {
        title: "最后PO供应商编号",
        dataIndex: "f117",
        width: 150,
        align: "center",
        search: false,
      },
      {
        title: "最后PO供应商名称",
        dataIndex: "f118",
        width: 180,
        align: "center",
        search: false,
      },
      {
        title: "1年内采购均价",
        dataIndex: "f119",
        width: 150,
        align: "center",
        search: false,
      },
      {
        title: "物料主数据价格单位",
        dataIndex: "f122",
        width: 180,
        align: "center",
        search: false,
      },
    ],
  });

  const rowSelection: TableProps<MaterialSapVo>["rowSelection"] = {
    type: "checkbox",
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRows(selectedRows);
    },
  };

  const handleOk = () => {
    if (selectedRows.length === 0) {
      notifyWarning("请选择物料");
      return;
    }
    onOk?.(selectedRows);
    handleClose();
  };

  const handleClose = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setParams({});
    onClose();
  };

  const footer = () => (
    <div style={{ textAlign: "center" }}>
      <PrimaryButton onClick={handleOk}>确定</PrimaryButton>
    </div>
  );

  return (
    <CommonModal
      title="选择物料"
      open={open}
      onCancel={handleClose}
      width={1200}
      style={{ top: 20 }}
      footer={footer}
    >
      <BaseProtable<MaterialSapVo>
        headerTitle={null}
        actionRef={actionRef}
        formRef={formRef}
        columns={columns}
        className={styles.modalProTable}
        rowSelection={rowSelection}
        rowKey="f101"
        bordered
        request={fetchDatasource}
        params={params}
        search={{
          labelWidth: "auto",
          span: 6,
        }}
        onSubmit={(values) => setParams({ ...values })}
      />
    </CommonModal>
  );
};
